import PDFViewer from "../pdf/PDFViewer";
import isEmpty from "../../validation/is-empty";
import { translate } from "../../utils/translation";
import PropTypes from "prop-types";

import "../drawings/Drawings.css";
import { DeletePCKeyDocButton } from "./PostContractKeyDocs.components";

PostContractKeyDocuments.propTypes = {
  project: PropTypes.object,
  user: PropTypes.object,
  postContractId: PropTypes.string,
  postContract: PropTypes.object,
};

export default function PostContractKeyDocuments(props) {
  const { project } = props;
  const { user } = props;
  const { postContractId } = props;
  const { postContract } = props;

  const report = postContract?.data?.find(
    (p) => p.PostContractId === postContractId
  );

  if (isEmpty(report)) {
    return (
      <div className="project-budget">
        {translate(
          "Post Contract Key Documents are available after a Post Contract has been uploaded"
        )}
      </div>
    );
  }

  if (isEmpty(report.keyDocuments)) {
    return (
      <div className="project-budget">
        {translate(
          "No Post Contract Key Documents has been uploaded. Please click Upload PDF button to add new documents"
        )}
      </div>
    );
  }

  let displayDrawings = [];
  report.keyDocuments.forEach((d) => {
    displayDrawings.push(
      <div key={d.id}>
        <PDFViewer
          documentId={d.documentId}
          deleteButton={
            <DeletePCKeyDocButton
              documentId={d.documentId}
              user={user}
              project={project}
              postContract={postContract}
              postContractId={postContractId}
            />
          }
        />
      </div>
    );
  });

  return <div className="estimate-drawings">{displayDrawings}</div>;
}
